export default class TimeZone {
  constructor() {
    var moment = require('moment-timezone');
    this.moment = moment;
    this.timeZones(this.moment);
  }

  timeZones(moment) {
    const form = document.querySelector('form');
    if (form) {
      const formId = form.getAttribute('id'),
      selectZone = $('#' + formId + '_zoneinfo');

      if (!selectZone.val()) {
        selectZone.val(moment.tz.guess());
      } else {
        selectZone.val();
      }
    }
  }
}
